export default "__VITE_ASSET__pFT3XnKQ__"